import { PhoneType } from '@app/models/enums'
import { IPhoneNumber, PhoneNumber } from '@app/models/PhoneNumber'
import { IGlobalConfigurationState } from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import { humanize } from '@app/utils/formatting'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { List } from 'immutable'
import * as React from 'react'
import InputMask from 'react-input-mask'
import { Button, Input, InputGroup, InputGroupAddon } from 'reactstrap'

interface IComponentProps {
  dataSource?: List<IPhoneNumber>
  onChange: (items: any) => void
}

interface IComponentState {
  phoneItems: List<IPhoneNumber>
}

export default class PhoneNumberList extends React.PureComponent<
  IComponentProps & IGlobalConfigurationState,
  IComponentState
> {
  public constructor(props: any) {
    super(props)

    this.state = {
      phoneItems: this.props.dataSource || List<IPhoneNumber>(),
    }

    bindFunctions(this)
  }

  public render() {
    return (
      <div className='d-flex flex-column'>
        <Button
          size='sm'
          className='mt-1 mb-2 mr-auto'
          onClick={() => this._addPhoneNumberItem()}
          color='primary'
        >
          <FontAwesomeIcon icon={['fal', 'plus']} fixedWidth />
          <span>Phone</span>
        </Button>
        {this._renderPhoneItems()}
      </div>
    )
  }

  private _renderPhoneItems() {
    return this.state.phoneItems.toArray().map((p, i) => {
      return (
        <div key={`phone-${i}`} className='d-flex flex-row mt-2'>
          <Input
            type='select'
            className='mr-2'
            value={p.type}
            onChange={(e) => this._editPhoneType(e.target.value, i)}
          >
            {this.props.configuration.phoneTypes
              .map((c, index) => (
                <option key={`phoneType-${index}`} value={c}>
                  {humanize(c)}
                </option>
              ))
              .toJS()}
          </Input>

          <InputGroup>
            <InputMask
              alwaysShowMask={true}
              className='form-control'
              mask='(999) 999-9999 ext. 999999'
              value={p.phoneNumber}
              onChange={(e) => this._editPhoneNumber(e.target.value, i)}
              required
            />
            <InputGroupAddon addonType='append'>
              <Button
                className='align-self-center'
                color='danger'
                onClick={() => this._removePhoneItem(i)}
              >
                <FontAwesomeIcon icon={['fal', 'trash']} fixedWidth />
              </Button>
            </InputGroupAddon>
          </InputGroup>
        </div>
      )
    })
  }

  private _removePhoneItem(index: number) {
    const items = this.state.phoneItems.remove(index) as List<PhoneNumber>
    this.props.onChange(items)
    this.setState({
      phoneItems: items,
    })
  }

  private _addPhoneNumberItem() {
    const items = this.state.phoneItems.push(
      new PhoneNumber({
        phoneNumber: '',
        type: PhoneType.Mobile,
      }),
    )
    this.props.onChange(items)
    this.setState({
      phoneItems: items,
    })
  }

  private _editPhoneNumber(value: string, index: number) {
    const cleanedPhoneNumber = value.replace(/[^0-9]/gm, '')
    const items = this.state.phoneItems.setIn(
      [index, 'phoneNumber'],
      cleanedPhoneNumber,
    ) as List<PhoneNumber>
    this.props.onChange(items)
    this.setState({
      phoneItems: items,
    })
  }

  private _editPhoneType(value: string, index: number) {
    const items = this.state.phoneItems.setIn([index, 'type'], value) as List<
      PhoneNumber
    >
    this.props.onChange(items)
    this.setState({
      phoneItems: items,
    })
  }
}
